@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.mobile-phone-payment.title' | apContent }}</div>
}
@if (showMobilePhonePaymentAmount()) {
    <mobile-phone-payment-amount></mobile-phone-payment-amount>
}
